export const HEADERS = ["Имя файла", "Код МКБ-10", "Дата обработки", ""];
